// import LoginMod from 'pages/login/loginMod';
import AppStore from 'widget/App/AppStore';

// 头部
import HeaderBarMod from "widget/HeaderBar/HeaderBarMod";
// 头部导航
import HeaderNavMod from "widget/HeaderNav/HeaderNavMod";
// 头部全局功能控制器
import HeaderGlobalMod from "widget/HeaderGlobal/HeaderGlobalMod";
// 产品列表
import ProductListMod from "pages/ProductList/ProductListMod";
// 产品子系统
import ProductDetailMod from "pages/ProductDetail/ProductDetailMod";

// 资源管理
import ApplicationResourcesMod from 'pages/ResourceManage/ApplicationResources/ApplicationResourcesMod'

//左侧边栏
import SiderBarMod from 'widget/SiderBar/SiderBarMod'
//登陆日志
import LogLoginMod from 'pages/LogManage/LogLogin/LogLoginMod'
//消息事件
import MessageEventsMod from 'pages/MessageManage/MessageEvents/MessageEventsMod'
//我的消息
import MyMessageMod from 'pages/MessageManage/MyMessage/MyMessageMod'
//消息详情配置
import MessageDetailMod from 'pages/MessageManage/MessageDetail/MessageDetailMod'
//手工推送消息
import ManuallySendMod from 'pages/MessageManage/ManuallySend/ManuallySendMod'
//手工推送消息详情
import ManuallyDetailMod from 'pages/MessageManage/ManuallyDetail/ManuallyDetailMod'

//调度Task管理
import TaskManageMod from 'pages/DispatchCenter/TaskManage/TaskManageMod'
//调度JOB管理
import JobManageMod from 'pages/DispatchCenter/JobManage/JobManageMod'
//调度job实例管理
import JobSampleManageMod from 'pages/DispatchCenter/JobSampleManage/JobSampleManageMod'
//调度报表
import ReportMod from 'pages/DispatchCenter/Report/ReportMod'

//---STORE_IMPORT---
// 上面这个标记不能去掉

export {
  // LoginMod,
  AppStore,
  HeaderBarMod,
  HeaderNavMod,
  ProductListMod,
  ProductDetailMod,
  HeaderGlobalMod,
  ApplicationResourcesMod,
  SiderBarMod,
  LogLoginMod,
  MessageEventsMod,
  MyMessageMod,
  MessageDetailMod,
  ManuallySendMod,
  ManuallyDetailMod,
  TaskManageMod,
  JobManageMod,
  JobSampleManageMod,
  ReportMod,
  //---STORE_EXPORT---
  // 上面这个标记不能去掉
}



// WEBPACK FOOTER //
// ./src/config/Stores.js